(function () {
  var w = window;
  var ic = w.Intercom;
  if (typeof ic === "function") {
    ic("reattach_activator");
    ic("update", w.intercomSettings);
  } else {
    var d = document;
    var i = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    w.Intercom = i;
    var l = function () {
      if (!document.head.querySelector("[name=intercom-id]")) {
        return;
      }
      var intercomId = document.head.querySelector("[name=intercom-id]")
        .content;
      var s = d.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://widget.intercom.io/widget/" + intercomId;
      var x = d.getElementsByTagName("script")[0];
      x.parentNode.insertBefore(s, x);
    };
    if (w.attachEvent) {
      w.attachEvent("onload", l);
      w.attachEvent("turbo:load", l);
    } else {
      w.addEventListener("load", l, false);
      w.addEventListener("turbo:load", l, false);
    }
  }
})();

window.addEventListener("turbo:load", function () {
  if (
    window.location.pathname !== "/app/help" &&
    window.location.pathname !== "/app/manage" &&
    window.location.pathname !== "/app/setup_manage" &&
    !window.location.pathname.startsWith("/app/manage/")
  ) {
    try {
      Intercom("shutdown");
    } catch (e) {
      // Intercom can throw when its iframes are detached during Turbo navigation
    }
  }
});
